<template>
  <div>
    <div>
      <x-grid
          :id="'formList'"
          :rowId="rowId"
          :url="url"
          :columns="columns"
          :form-config="formConfig"
          :toolbar-config="toolbarConfig"
          :print-config="printConfig"
          :pager-config="pagerConfig"
          :checkbox-config="checkboxConfig"
          :export-config="exportConfig"
          ref="grid"
          :cellClick="chooseRow"
          :cellDbClick="updateRow"
      >
        <template v-slot:operate="{row}">
          <vxe-button style="margin-right: 10px" size="mini" status="primary" @click="updateRow({row})">查看详情</vxe-button>
        </template>
      </x-grid>
    </div>
    <!-- 详情页 -->
    <formModal
        title="意向大客户详情"
        centered
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        :width="1200"
        :closable="true"
        @cancelled="closeDetailPop"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <detailForm
          :rowId="editRowId"
          v-if="editModalVisible"
          ref="detailForm"
      >
      </detailForm>
    </formModal>
  </div>
</template>

<script>
import XGrid from "@/components/grid/XGrid";
import api from "@/services/api";
import {GridMixin} from "@/utils/GridMixin";
import {dataApi} from "@/services/clue/clueManage";
import {loadBaseCodeData} from "@/services/baseCodeSource";
import {bigDataApi} from "@/services/bigCustomer/followRecord";
import detailForm from "@/pages/web/bigCustomer/followRecord/followRecordDetail";

const fac = XGrid.factory;
//列表接口
const url = api.followRecord.VISIT;
//主键
const rowId = "id";
//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("customerName", "客户名称", 120),
  fac.makeColumn("name", "联系人姓名", 120),
  fac.makeColumn("contactPhone", "联系方式", 120),
  fac.makeColumn("visitUserName", "拜访人", 120),
  fac.makeColumn("visitUserDeptName", "拜访人部门", 120),
  fac.makeColumn("visitCreateDate", "拜访时间", 150),
  fac.makeColumn("lastSaleUserName", "最近跟进人", 120),
  fac.makeColumn("lastFollowDeptName", "最近跟进人部门", 120),
  fac.makeColumn("lastCallonDate", "最近跟进时间", 150),
  fac.makeColumn("nextCallonDate", "下次跟进时间", 150),
  fac.makeColumn("wantStrainName", "意向品系", 120),
  fac.makeColumn("nextWantLevelName", "意向等级", 120),
  fac.makeColumn("wantCount", "预购数量", 120),
  fac.makeColumn("dealCount", "成交数量", 120),
  fac.makeColumn("dealDate", "成交时间", 150),
  fac.makeColumn("failDate", "战败时间", 150),
  fac.makeColumn("failReason", "战败原因", 200),
  fac.makeColumn("lostNum", "战败数量", 100),
  fac.makeColumn("dealChanceName", "成交概率", 120),
  fac.makeColumn({
    title: "操作",
    field: 'operate',
    slots: {
      default: 'default'
    },
    align: 'center',
    width: 200,
    fixed:'right'
  }),
];

//筛选条件
const formConfig = fac.makeFormConfig(columns, [
  {field: "customerName", title: "客户名称", customSearch: true},
  {field: "name", title: "联系人姓名", customSearch: true},
  {field: "contactPhone", title: "联系方式", customSearch: true},
  {field: "lastSaleUserName", title: "最近跟进人", customSearch: true},
  {field: "lastFollowDeptId", title: "最近跟进人部门", type: "select", options: [], customSearch: true},
  {field: 'lastCallonDate', title: "最近跟进时间", type: 'dateRange', customSearch: true},
  {field: 'nextCallonDate', title: "下次跟进时间", type: 'dateRange', customSearch: true},
  {field: "wantStrain", title: "意向品系", type: "select", options: [], customSearch: true},
  {field: "nextWantLevel", title: "意向等级", type: "select", options: [], customSearch: true},
  {field: 'dealDate', title: "成交时间", type: 'dateRange', customSearch: true},
  {field: 'failDate', title: "战败时间", type: 'dateRange', customSearch: true},
  {field: "visitUserName", title: "拜访人", customSearch: true},
  {field: "visitUserDeptId", title: "拜访人部门", type: "select", options: [], customSearch: true},
  {field: "visitCreateDate", title: "拜访时间", type: "dateRange", customSearch: true},
]);

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  addData: false,
  export: true,
  import: false,
  delData: false,
  templatelSlots: "toolbarBtns",
});

//可编辑表格约束
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

//初始化数据方法
async function loadBaseData() {
  //最近跟进人部门、拜访人部门
  this.regionOptions = await bigDataApi.selection()
  this.regionOptions = this.regionOptions.data.map(v => {
    return {
      label: v.deptName,
      value: v.deptId
    }
  })
  this.regionOptions = [{
    value: '',
    label: '全部'
  }].concat(this.regionOptions);
  this.loadSearchOption({
    lastFollowDeptId: this.regionOptions,
  })
  this.loadSearchOption({
    visitUserDeptId: this.regionOptions,
  })
  //意向品系
  let strainData = await dataApi.getStrainList()
  this.strainOptions = strainData.data.map(v => {
    return {
      label: v.strainName,
      value: v.strainId,
    }
  })
  this.strainOptions = [{
    value: '',
    label: '全部'
  }].concat(this.strainOptions);
  this.loadSearchOption({
    wantStrain: this.strainOptions,
  })
  //意向等级
  this.wantLevelOptions = await loadBaseCodeData('CD200002')
  this.wantLevelOptions = this.wantLevelOptions.map(v => {
    return {
      label: v.label,
      value: v.value
    }
  })
  this.wantLevelOptions = [{
    value: '',
    label: '全部'
  }].concat(this.wantLevelOptions);
  this.loadSearchOption({
    nextWantLevel: this.wantLevelOptions,
  })
}

export default {
  mixins: [GridMixin],
  components: {
    detailForm,
  },
  data() {
    return {
      rowId,
      url,
      columns,
      formConfig,
      toolbarConfig,
      printConfig,
      pagerConfig,
      checkboxConfig,
      exportConfig:{
        remote: true,
        types: ['xlsx'],
        modes: ['all']
      },
      strainOptions: [],
      wantLevelOptions: [],
      regionOptions: [],
      editModalVisible: false,
    };
  },
  methods: {
    //关闭详情弹窗
    closeDetailPop() {
      this.editModalVisible = false;
    },
    loadBaseData,
  },
};
</script>

<style scoped lang="less">
//新增的开始
/deep/ .ant-radio-group {
  display: flex;
  width: 100%;

  .ant-radio-wrapper {
    flex: 1;
  }

  .item {
    margin: 16px 0;
  }
}

.left_tree {
  width: 260px;
  float: left;
  padding: 20px;
  height: calc(100vh - 48px - 64px);
  border-right: 1px solid #e0e0e0;
  background: #fff;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
}

.right_table {
  width: calc(100% - 260px);
  float: right;
  height: 100%;
  position: relative;

  .close {
    position: absolute;
    top: 50%;
    left: -18px;
    display: block;
    z-index: 1000;
    font-size: 36px;
    cursor: pointer;
    color: #fff;
    background-color: #bbb;
    border-radius: 18px;
  }
}

.showLeft {
  width: 100%;
}
</style>
